import React from 'react'

import { dynamicBullets, imageGalleryBullets } from './styles.css'

type ImageGalleryBulletsProps = {
  currentIndex: number
  totalItems: number
}

export const ImageGalleryBullets: React.FC<ImageGalleryBulletsProps> = ({ currentIndex, totalItems }) => {
  return (
    <div className={imageGalleryBullets}>
      {Array.from(Array(totalItems).keys()).map((index) => {
        const isInView =
          Math.abs(currentIndex - index) <= 2 ||
          (currentIndex <= 1 && index <= 4) ||
          (currentIndex >= totalItems - 3 && index >= totalItems - 5)
        return <DynamicBullet key={`dynamic-bullet-${index}`} isCurrent={index === currentIndex} isInView={isInView} />
      })}
    </div>
  )
}

const DynamicBullet: React.FC<{ isCurrent: boolean; isInView: boolean }> = ({ isCurrent, isInView }) => {
  return <div className={dynamicBullets({ isCurrent, isInView })} />
}
